import JsCookie from 'js-cookie'
import removeAllCookiesFactory from 'delete-all-cookies'

import { Settings } from 'services/settings'

export class Cookies {
  constructor(converter = null) {
    this.service = this.initService(converter)
    this.defaults = {
      expires: 14,
      sameSite: 'Lax'
    }
    this.removeAllCookies = removeAllCookiesFactory(window)
  }

  setCookie(name, value, options = {}) {
    this.service.set(name, value, {
      path: '/',
      expires: options.expires || this.defaults.expires,
      secure: Settings.force_ssl,
      sameSite: options.sameSite || this.defaults.sameSite
    })
  }

  getCookie(name) {
    return this.service.get(name)
  }

  removeCookie(name) {
    return this.service.remove(name)
  }

  removeAll() {
    this.removeAllCookies()
  }

  initService = (converter) => {
    if (converter) {
      return JsCookie.withConverter(converter)
    }
    return JsCookie
  }
}
